import Menu from './Menu'
import enhance from './Menu.enhancer'

export default enhance(Menu)



// WEBPACK FOOTER //
// ./src/App/components/Menu/components/index.js